import { create } from "zustand";
import { persist } from "zustand/middleware";

import {
  createUserTenantChangeListener,
  createUserTenantStorage,
} from "./tenant-storage-helpers";

interface AppointmentNotificationStore {
  sendCancellationMessage: boolean;
  setSendCancellationMessage: (value: boolean) => void;
  sendNoShowMessage: boolean;
  setSendNoShowMessage: (value: boolean) => void;
  sendUpdateNotification: boolean;
  setSendUpdateNotification: (value: boolean) => void;
  sendCreateSmsConfirmation: boolean;
  setSendCreateSmsConfirmation: (value: boolean) => void;
}

const defaultAppointmentNotificationPreferences = {
  sendCancellationMessage: true,
  sendNoShowMessage: true,
  sendUpdateNotification: true,
  sendCreateSmsConfirmation: true,
};

export const useAppointmentNotificationStore =
  create<AppointmentNotificationStore>()(
    persist(
      (set) => ({
        ...defaultAppointmentNotificationPreferences,
        setSendCancellationMessage: (value) =>
          set({ sendCancellationMessage: value }),
        setSendNoShowMessage: (value) => set({ sendNoShowMessage: value }),
        setSendUpdateNotification: (value) =>
          set({ sendUpdateNotification: value }),
        setSendCreateSmsConfirmation: (value) =>
          set({ sendCreateSmsConfirmation: value }),
      }),
      {
        name: "appointment-notification-store",
        partialize: (state: AppointmentNotificationStore) => ({
          sendCancellationMessage: state.sendCancellationMessage,
          sendNoShowMessage: state.sendNoShowMessage,
          sendUpdateNotification: state.sendUpdateNotification,
          sendCreateSmsConfirmation: state.sendCreateSmsConfirmation,
        }),
        storage: createUserTenantStorage(),
      },
    ),
  );

createUserTenantChangeListener(
  "appointment-notification-store",
  (persistedPreferences) => {
    useAppointmentNotificationStore.setState({
      ...defaultAppointmentNotificationPreferences,
      ...persistedPreferences,
    });
  },
);
